export default __webpack_public_path__ + "static/media/pic.fb8b5e32.png";